<footer class="footer">
  <section class="footer-wrap">
    <div class="footer-container">
      <a [routerLink]="['']" class="footer-logo">
        <img src="assets/images/logo.svg" alt="logo" height="36" width="116">
      </a>
      <div class="footer-content">
        <p class="footer-text">Smileloan.co.za is a completely free, independent loan comparison service. We are not influenced by any lender — our only compensation comes from successfully disbursed loans, allowing us to stay fair, transparent, and unbiased.
        </p>
        <p class="copyright footer-text">2025</p>
      </div>
    </div>
  </section>
</footer>

